const typographyModalEquipServiceGroup = {
  true: 'Create',
  false: 'Edit',
  text: 'Section'
};

export default typographyModalEquipServiceGroup;
